import httpService from '../Api/http.service';
import { getApiBaseUrl } from 'utils';

const getAppCoreBaseUrl = () => `${getApiBaseUrl()}/appcore`;

const initPylonChat = () =>
  httpService({
    url: getAppCoreBaseUrl() + '/pylon/init',
    method: 'post',
  });

const pylonService = {
  initPylonChat,
};

export default pylonService;
